<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <b-card title="Register a Referral" type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5">
                    <b-card-text>
                        <b-form @submit="onSubmit" enctype="multipart/form-data">
                            <b-form-group id="input-group-1" label="Full Name:" label-for="input-1">
                                <b-form-input id="input-1" v-model="form.name" placeholder="Enter full name" required>
                                </b-form-input>
                            </b-form-group>

                            <b-form-group id="input-group-2" label="Referral Phone Number:">
                                <b-form-input maxlength="10" id="input-1" v-model="form.mobile" placeholder="Enter phone number" required>
                                </b-form-input>
                                <div><span class="text-warning">{{valideReceiverNumberMessage}}</span></div>

                            </b-form-group>
                            <b-form-group id="input-group-3" label="Address:" label-for="textarea">
                                <b-form-textarea id="textarea" v-model="form.address" placeholder="Address" rows="3"
                                    max-rows="6"></b-form-textarea>
                            </b-form-group>
                            <b-form-group id="input-group-4" label="Referral Postal Code:" label-for="input-4">
                                <b-form-input id="input-4" v-model="form.postalcode" placeholder="Referral Postal Code" required>
                                </b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-5" label="Referral Provice:" label-for="input-5">
                                <b-form-select class="mb-3" placeholder="Province" v-model="form.province" :options="options"></b-form-select>
                            </b-form-group>
                            <b-form-group id="input-group-6" label="Upload picture of National ID or Passport:" label-for="input-6">
                                <input
                                alternative
                                @change="onFileChanged"
                                class="mb-3"
                                type="file"
                                accept="image/*"
                                addon-left-icon="ni ni-badge"
                              />
                            </b-form-group>
                            <b-button type="submit" variant="primary" class="my-4">Submit Referral</b-button>
                        </b-form>
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
</div>